// Configure PILLAR API with frontend-specific session handling
import { createPillarApi } from '@anchorbase/pillar-sdk';
import { handleSessionExpired } from './sessionManager';
import { setTraceContextHeader } from './logging/frontend-logger';

const pillarApi = createPillarApi(handleSessionExpired, '/api', setTraceContextHeader);

export const authApi = pillarApi.authApi;
export const userApi = pillarApi.userApi;
export const organizationApi = pillarApi.organizationApi;
export const customerApi = pillarApi.customerApi;
export const paymentsInfrastructureApi = pillarApi.paymentsInfrastructureApi;
export const sambaApi = pillarApi.sambaApi;
export const sambaConfigApi = pillarApi.sambaConfigApi;
export const diagnosticsApi = pillarApi.diagnosticsApi;
export const encryptionKeysApi = pillarApi.encryptionKeysApi;
export const secretsApi = pillarApi.secretsApi;
export const rpaCredentialInjectionApi = pillarApi.rpaCredentialInjectionApi;
export const ipxCredentialManagementApi = pillarApi.ipxCredentialManagementApi;
export const permissionsApi = pillarApi.permissionsApi;
export const authorizationApi = pillarApi.authorizationApi;
export const legalDocumentsApi = pillarApi.legalDocumentsApi;
export const auditApi = pillarApi.auditApi;
export const loggingApi = pillarApi.loggingApi;
export const paymentsApi = pillarApi.paymentsApi;
export const allowedWebsiteTemplatesApi = pillarApi.allowedWebsiteTemplatesApi;

// Re-export ApiError for backward compatibility
export { ApiError } from '@anchorbase/pillar-sdk';
